import { useState } from "react";
import Icon from "@/components/Icon";

// Shows a real favicon for http(s) links; falls back to the lucide icon.
export default function LinkThumb({ link, className = "" }) {
  const [failed, setFailed] = useState(false);
  const isHttp = /^https?:\/\//i.test(link.url);

  let host = "";
  if (isHttp) {
    try {
      host = new URL(link.url).hostname;
    } catch {
      host = "";
    }
  }

  const showFavicon = isHttp && host && !failed;

  return (
    <div className={className}>
      {showFavicon ? (
        <img
          src={`https://www.google.com/s2/favicons?domain=${host}&sz=64`}
          alt=""
          onError={() => setFailed(true)}
          className="h-5 w-5 rounded-sm object-contain"
          loading="lazy"
        />
      ) : (
        <Icon name={link.icon} className="h-4 w-4" />
      )}
    </div>
  );
}
